export interface PaginationState {
  pageNumber: number;
  pageSize: number;
}

export const INITIAL_PAGINATION_STATE: PaginationState = {
  pageNumber: 1,
  pageSize: 10,
};
